import { useState, useEffect } from "react";

const useDfpSlot = ( { path, size, id, adRendered = () => { } } ) => {
	const [ display, setDisplay ] = useState ( false );

	useEffect ( () => {
		const googletag = window.googletag || {};

		googletag.cmd = googletag.cmd || [];
		googletag.cmd.push ( () => {
			googletag.defineSlot ( path, size, id ).addService ( googletag.pubads () );
			googletag.pubads ().setCentering ( true );
			googletag.pubads ().addEventListener ( "slotRenderEnded", event => {
				if ( !event.isEmpty ) {
					setDisplay ( true );
					adRendered ();
				}
			} );
			googletag.pubads ().enableSingleRequest ();
			googletag.enableServices ();
			googletag.display ( id );
		} );
	}, [ path, size, id ] );

	return (
		<div
			id = { id }
			style = { { display: display ? "block" : "none" } }
		/>
	);
};

export default useDfpSlot;
